/* Este archivo es autogenerado por scripts/setenv.ts. NO EDITAR MANUALMENTE. */
export const environment = {
  production: false,
  COGNITO_USERPOOL_ID: "us-east-2_zOrwjGFhY",
  COGNITO_APPCLIENT_ID: "5917bbqffinhha64pchetlcse",
  API_URL: "https://dev-api.dohealth-epione.com/epione-medtronic-surgical-api",
  CORE_API_URL: "https://dev-api.dohealth-epione.com/epione-core-api",
  WS_TICKET_URL: "https://dev-api.dohealth-epione.com/ws/ticket/create",
  WS_BASE_URL: "wss://ws.dev.dohealth-epione.com",
};
